import React, { useEffect } from "react"
import * as styles from "./ParallaxSection.module.css"
import cloud1 from "../../images/on-going-projects/the-edge/images/cloud1Mask.jpg";
import cloud2 from "../../images/on-going-projects/the-edge/images/cloud2.webp";
import cloud3 from "../../images/on-going-projects/the-edge/images/cloud1.png";
import cloud4 from "../../images/on-going-projects/the-edge/images/cloud3.png";
import image1 from "../../images/on-going-projects/the-edge/images/03.png";
import image2 from "../../images/on-going-projects/the-edge/images/04.png";




const ParallaxSection = () => {
  useEffect(() => {
    // Load GSAP and ScrollTrigger
    const loadGSAP = async () => {
      if (typeof window !== "undefined") {
        const gsap = (await import("gsap")).default
        const ScrollTrigger = (await import("gsap/ScrollTrigger")).default

        gsap.registerPlugin(ScrollTrigger)

        const section = document.getElementById('parallax-svg-section')

        if (section) {
          gsap.set(section.querySelector('.main'), {
            position: 'relative',
            background: '#fff',
            width: '100%',
            maxWidth: '2000px',
            height: '100%',
            margin: '0 auto'
          })

          gsap.set(section.querySelector('.scrollDist'), {
            width: '100%',
            height: '200vh'
          })

          gsap.timeline({
            scrollTrigger: {
              trigger: section.querySelector('.scrollDist'),
              start: 'top top',
              end: 'bottom bottom',
              scrub: 1,
              invalidateOnRefresh: true
            }
          })
            .fromTo('.sky', { y: 0 }, { y: -200 }, 0)
            .fromTo('.cloud1', { y: 100 }, { y: -800 }, 0)
            .fromTo('.cloud2', { y: -150 }, { y: -500 }, 0)
            .fromTo('.cloud3', { y: -50 }, { y: -650 }, 0)
            .fromTo('.mountBg', { y: -10 }, { y: -100 }, 0)
            .fromTo('.mountMg', { y: -30 }, { y: -250 }, 0)
            .fromTo('.mountFg', { y: -50 }, { y: -600 }, 0)

          window.addEventListener('resize', () => ScrollTrigger.refresh())
        }
      }
    }

    loadGSAP()

    return () => {
      if (typeof window !== "undefined" && window.ScrollTrigger) {
        window.ScrollTrigger.getAll().forEach(trigger => trigger.kill())
      }
    }
  }, [])

  return (
    <section id="parallax-svg-section" className={styles.parallaxSection}>
      {/* Scroll Trigger Spacer */}
      <div className="scrollDist" style={{ position: 'absolute', width: '100%', height: '200vh', top: 0, left: 0, pointerEvents: 'none', zIndex: 0 }}></div>

      {/* Main SVG Container */}
      <div className="main" style={{ position: 'relative', width: '100%', height: '100%', maxWidth: '2000px', margin: '0 auto', overflow: 'hidden' }}>
        <svg viewBox="0 0 1200 800" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', height: '100%', display: 'block' }}>

          {/* Text Mask */}
          <mask id="m">
            <g className="cloud1">
              <rect fill="#fff" width="100%" height="801" y="799" />
              <image xlinkHref={cloud1} width="1200" height="800" />
            </g>
          </mask>

          {/* Parallax Layers */}
          <image className="sky" xlinkHref={image2} width="1200" height="590" />
          <image className="mountMg" xlinkHref={image1} width="1200" height="800" x="-820" y="200" transform="scale(-1, 1)" />
          <image className="cloud2" xlinkHref={cloud2} width="1200" height="800" />
          <image className="mountFg" xlinkHref={image2} width="1200" height="800" x="370" y="200" />
          <image className="cloud1" xlinkHref={cloud3} width="1200" height="800" />
          <image className="cloud3" xlinkHref={cloud4} width="1200" height="800" />

          {/* Top Text */}
          <text fill="url(#exploreGradient)" x="10" y="200" fontWeight="900" fontSize="100" fontFamily="Cormorant">EXPLORE</text>

          {/* Masked Text Effect */}
          <g mask="url(#m)" className="top-text">
            <rect fill="#fff" width="100%" height="100%" />
            <text x="750" y="600" fill="url(#royaltyGradient)" fontWeight="900" fontSize="80" className="top-text" fontFamily="Cormorant">ROYALTY</text>
          </g>

          {/* Drop Shadow Filter */}
          <defs>

            <linearGradient id="exploreGradient" gradientUnits="objectBoundingBox"
              x1="0%" y1="0%" x2="100%" y2="10%">
              <stop offset="5.56%" stopColor="#2F4145" />
              <stop offset="53.31%" stopColor="#94B0D5" />
              <stop offset="98.19%" stopColor="#2F4145" />
            </linearGradient>
            <linearGradient id="royaltyGradient" gradientUnits="objectBoundingBox"
              x1="100%" y1="100%" x2="0%" y2="10%">
              <stop offset="5.46%" stopColor="#8C5738" />
              <stop offset="46.85%" stopColor="#D4B48D" />
              <stop offset="95.85%" stopColor="#8C5738" />
            </linearGradient>

            <filter id="dropShadow" x="-50%" y="-50%" width="200%" height="200%">
              <feDropShadow dx="2" dy="2" stdDeviation="2" floodColor="#000" floodOpacity="0.3" />
            </filter>
          </defs>

        </svg>
      </div>
    </section>
  )
}

export default ParallaxSection
